import { gql } from '@apollo/client'

// REFRESH_SESSION

export default gql`
  mutation refreshSession {
    refreshSession {
      token
      token_expires_at_iso
      message
      remained_attempts
      locked
      authenticated
    }
  }
`
